import { isGdprCountry } from '@change-corgi/config/countries';

import type { SignFormExperiments } from 'src/app/pages/petitionDetails/shared/types';

export function isGdprEnabled(countryCode: string | undefined, experiments: SignFormExperiments): boolean {
	return experiments.gdpr.enabled && !!countryCode && isGdprCountry(countryCode);
}
